module.exports = __webpack_public_path__ + "static/media/38-5.06089594.mp3";